import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AnnounceBar from './components/AnnounceBar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import PolicyModal from './components/PolicyModal';
import FaqPage from './components/FaqPage';
import SupportPage from './components/SupportPage';
import HomePage from './pages/HomePage';
import ScrollManager from './components/ScrollManager';
import Analytics from './components/Analytics';

export default function App() {
  return (
    <>
      <ScrollManager />
      <Analytics />
      <AnnounceBar />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/faq" element={<Navigate to="/faq/customer/" replace />} />
          <Route path="/faq/:audience" element={<FaqPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/policies/:appKey" element={<PolicyModal />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
